import { type ReactElement, type ReactNode } from 'react';

import type { WatchInvestigationFieldChange } from './types';

import styles from './scss/TargetedMarketing.module.scss';

interface IInvestigationDiff {
  before: string,
  after: string,
}

export function InvestigationDiff({ before, after }: IInvestigationDiff): ReactElement {
  if (before === after) {
    return <span>{after || '—'}</span>;
  }
  return (
    <span className={styles.diffInline}>
      <span className={styles.diffRemoved}>{before || '—'}</span>
      {' '}
      <span className={styles.diffAdded}>{after || '—'}</span>
    </span>
  );
}

interface IInvestigationField {
  label: string,
  htmlFor: string,
  className?: string,
  change: WatchInvestigationFieldChange | null,
  reviewing: boolean,
  children: ReactNode,
}

function InvestigationField({
  label,
  htmlFor,
  className,
  change,
  reviewing,
  children,
}: IInvestigationField): ReactElement {
  return (
    <div className={className}>
      <label htmlFor={htmlFor}>{label}</label>
      {reviewing && change ? (
        <InvestigationDiff before={change.before} after={change.after} />
      ) : children}
    </div>
  );
}

InvestigationField.defaultProps = {
  className: undefined,
};

export default InvestigationField;
